import React from 'react';
import { EyeIcon, LockIcon } from 'lucide-react';
interface AudienceTagProps {
  borrower: boolean;
}

/** Visible marker separating borrower-facing items from internal ones. */
export function AudienceTag({
  borrower
}: AudienceTagProps) {
  return borrower ? <span className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium text-amber-800 ring-1 ring-inset ring-amber-200 bg-amber-50" data-id="element-70" data-mp="f38ve6bu70s5">
      <EyeIcon className="h-3 w-3" aria-hidden="true" data-id="element-71" data-mp="16xj9ucyqlalt" />
      Borrower can see
    </span> : <span className="inline-flex items-center gap-1 rounded bg-slate-100 px-1.5 py-0.5 text-[11px] font-medium text-slate-600 ring-1 ring-inset ring-slate-200" data-id="element-72" data-mp="1bu1df9ibz2wk">
      <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-73" data-mp="12uea2i61jn0v" />
      Internal
    </span>;
}